import {
  FaCalendarAlt,
  FaCalendarCheck,
  FaCogs,
  FaFileMedical,
  FaHandHoldingMedical,
  FaHeadset,
  FaHospitalUser,
  FaMicroscope,
  FaMoneyBill,
  FaDatabase,
  FaProcedures,
  FaShoppingCart,
  FaSyringe,
  FaClipboardList,
  FaTv,
  FaCreditCard
} from 'react-icons/fa'
import { FaBed, FaHeartPulse, FaPeopleGroup } from 'react-icons/fa6'
import { PiHandArrowDownBold, PiPhoneDisconnectFill } from 'react-icons/pi'
import { RiAdminFill, RiFileList3Line } from 'react-icons/ri'
import { BsFillClipboard2DataFill } from 'react-icons/bs'
import {
  MdMedicalServices,
  MdOutlineInventory2,
  MdVerified,
  MdBatchPrediction
} from 'react-icons/md'
import { HiDocumentReport, HiOutlineShieldExclamation } from 'react-icons/hi'
import { GiScalpelStrike } from 'react-icons/gi'

export const sidebarLinks = (
  t,
  isReceptionist = false,
  isAdmin = false,
  isManager = false,
  loggedUser = {},
  isAccountant = false,
  isNurse = false,
  isPractitioner = false,
  isRcmAssistant = false
) => {
  const isNurseRole = Number(loggedUser?.role?.id) === 4
  const isSuperAdmin = loggedUser?.role?.name_en === 'Super Admin'
  const separateWalkinAndSlots =
    loggedUser?.settings?.visit_settings?.separate_walkin_and_slots || false

  return [
    ...(!isNurseRole
      ? [
        {
          id: 1,
          label: t('Dashboard'),
          icon: <FaHeartPulse className='text-[15px]' />,
          link: isSuperAdmin ? '/system-health-dashboard' : '/dashboard',
          moduleName: 'dashboard'
        }
      ]
      : []),
    ...(isRcmAssistant
      ? [
         {
      id: 2000000,
      label: t('Approval Management'),
      icon: <MdVerified className='text-[15px]' />,
      link: '/approval-management',
      moduleName: 'approval_management'
    }]:[]),
  
    ...(isSuperAdmin
      ? [
        {
          id: 2000001,
          label: t('Minio'),
          icon: <FaDatabase className='text-[15px]' />,
          link: '/minio',
          moduleName: 'dashboard'
        }
      ]
      : []),
    ...(isAccountant ||
      ((isReceptionist || isAdmin || isManager) && separateWalkinAndSlots)
      ? [
        {
          id: 2,
          label: t('Visits(Walk-in)'),
          icon: <PiPhoneDisconnectFill className='text-[15px]' />,
          link: '/create-visit-without-slot',
          moduleName: 'visit'
        }
      ]
      : []),
    {
      id: 2,
      label:
        separateWalkinAndSlots || isAccountant
          ? t('Slots')
          : t('Visits(Walk-in)'),
      icon: <PiPhoneDisconnectFill className='text-[15px]' />,
      link: '/visits',
      moduleName: 'visit'
    },
    ...(isNurse
      ? [
        {
          id: 21,
          label: t('Nursing Station'),
          icon: <FaHospitalUser className='text-[15px]' />,
          link: '/nursing-station',
          moduleName: 'visit'
        }
      ]
      : []),
    ...(isPractitioner
      ? [
        {
          id: 21,
          label: t('Admissions'),
          icon: <FaBed className='text-[15px]' />,
          link: '/practitioner-admissions',
          moduleName: 'patientAdmission'
        }
      ]
      : []),
    {
      id: 3,
      label: t('Sessions'),
      icon: <RiFileList3Line className='text-[15px]' />,
      link: '/orders',
      moduleName: 'order'
    },
    {
      id: 4,
      label: t('Handover'),
      icon: <PiHandArrowDownBold className='text-[15px]' />,
      link: '/hand-over',
      moduleName: 'counter'
    },
    ...(!isNurseRole
      ? [
        {
          id: 5,
          label: t('Beneficiary'),
          icon: <FaPeopleGroup className='text-[15px]' />,
          link: '/beneficiary',
          moduleName: 'patient'
        }
      ]
      : []),
    {
      id: 6,
      label: t('Eligibility'),
      icon: <FaHandHoldingMedical className='text-[15px]' />,
      link: '/eligibility',
      moduleName: 'eligibility'
    },
    {
      id: 7,
      label: t('Claims'),
      icon: <HiOutlineShieldExclamation className='text-[15px]' />,
      link: '/claims',
      moduleName: 'cliamgeneration'
    },
    // {
    //   id: 72,
    //   label: t('Bulk Claims Batches'),
    //   icon: <MdBatchPrediction className='text-[15px]' />,
    //   link: '/bulk-claims-batches',
    //   moduleName: 'cliamgeneration'
    // },
    {
      id: 8,
      label: t('Billing'),
      icon: <FaMoneyBill className='text-[15px]' />,
      link: '/billing',
      moduleName: 'billing'
    },
    ...(isAccountant || isAdmin || isManager
      ? [
        {
          id: 9,
          label: t('Patient Deposit Balance'),
          icon: <FaMoneyBill className='text-[15px]' />,
          link: '/deposit-list',
          moduleName: 'deposit'
        }
      ]
      : []),
    ...(isAccountant || isAdmin || isManager
      ? [
        {
          id: 9,
          label: t('Patient Credit Balance'),
          icon: <FaCreditCard className='text-[15px]' />,
          link: '/patients-credit-list',
          moduleName: 'patientCreditBalance'
        }
      ]
      : []),
    {
      id: 9,
      label: t('Appointment'),
      icon: <FaCalendarAlt className='text-[15px]' />,
      link: '/appointments',
      moduleName: 'appointments'
    },
    {
      id: 10,
      label: t('Forms Creation'),
      icon: <BsFillClipboard2DataFill className='text-[15px]' />,
      link: '/forms-list',
      moduleName: 'forms-creation'
    },
    {
      id: 11,
      label: t('Admin Actions'),
      icon: <RiAdminFill className='text-[15px]' />,
      link: '/management',
      moduleName: 'management',
      allowCallCenter: true
    },
    {
      id: 13,
      label: t('Reports'),
      icon: <HiDocumentReport className='text-[15px]' />,
      link: '/billing-reports',
      moduleName: 'Reports'
    },
    {
      id: 130,
      label: t('GL Posting'),
      icon: <FaMoneyBill className='text-[15px]' />,
      link: '/gl-posting',
      moduleName: 'billing'
    },

    ...(Number(loggedUser?.business_id) === 1
      ? [
        {
          id: 12,
          label: t('Emergency'),
          icon: <MdMedicalServices className='text-[15px]' />,
          link: '/emergency',
          moduleName: 'emergency'
        },
        {
          id: 14,
          label: t('Help Desk'),
          icon: <FaHeadset className='text-[15px]' />,
          link: '/help-desk',
          moduleName: 'order'
        },
        {
          id: 15,
          label: t('CSSD'),
          icon: <GiScalpelStrike className='text-[15px]' />,
          link: '/cssd',
          moduleName: 'order'
        },
        {
          id: 16,
          label: t('Medical Records'),
          icon: <FaFileMedical className='text-[15px]' />,
          link: '/medical-records',
          moduleName: 'order'
        },
        {
          id: 17,
          label: t('Operation Theatre'),
          icon: <FaProcedures className='text-[15px]' />,
          link: '/operation-theatre',
          moduleName: 'order'
        },
        {
          id: 18,
          label: t('Vaccination'),
          icon: <FaSyringe className='text-[14px]' />,
          link: '/vaccination',
          moduleName: 'order'
        },
        {
          id: 19,
          label: t('BioMedical'),
          icon: <FaMicroscope className='text-[14px]' />,
          link: '/bio-medical',
          moduleName: 'order'
        },
        {
          id: 20,
          label: t('FMS and Operations'),
          icon: <FaCogs className='text-[14px]' />,
          link: '/fms-operations',
          moduleName: 'order'
        },
        {
          id: 21,
          label: t('ADT'),
          icon: <FaHospitalUser className='text-[14px]' />,
          link: '/adt',
          moduleName: 'order'
        },
        {
          id: 22,
          label: t('Supply Chain'),
          icon: <MdOutlineInventory2 className='text-[14px]' />,
          link: '/inventory',
          moduleName: 'inventory'
        },
        {
          id: 23,
          label: t('Queue Management'),
          icon: <FaClipboardList className='text-[14px]' />,
          link: '/queue-management',
          moduleName: 'order'
        },
        {
          id: 24,
          label: t('Queue Dashboard'),
          icon: <FaTv className='text-[14px]' />,
          link: '/queue-dashboard',
          moduleName: 'order'
        },
        {
          id: 25,
          label: t('Procurement'),
          icon: <FaShoppingCart className='text-[14px]' />,
          link: '/procurement',
          moduleName: 'procurement'
        },
        {
          id: 26,
          label: t('shift_scheduling'),
          icon: <FaCalendarCheck className='text-[14px]' />,
          link: '/shift-scheduling',
          moduleName: 'shift'
        },
        // {
        //   id: 27,
        //   label: t('bed_management'),
        //   icon: <FaHospitalUser className='text-[14px]  ' />,
        //   link: '/bed-management',
        //   moduleName: 'bed'
        // },
        // {
        //   id: 28,
        //   label: t('in_patient_management'),
        //   icon: <FaHospitalUser className='text-[14px]  ' />,
        //   link: '/addmission-office',
        //   moduleName: 'ward'
        // }
      ]
      : [])
  ]
}
